import { Box, Typography } from "@mui/material";
import React from "react";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import "./Importantinfo.css";
import "../CSS/Background.css";

export default function ImportantInfo() {
  // Structured data for SEO
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Your Christmas Tree Company",
    "description": "Premium Christmas tree lot in West Los Angeles offering delivery service",
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday"
      ],
      "opens": "10:00",
      "closes": "21:00"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Christmas Tree Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Christmas Tree Delivery",
            "description": "We deliver Christmas trees to your home"
          }
        }
      ]
    },
    "event": {
      "@type": "Event",
      "name": "Christmas Tree Lot Opening Day",
      "startDate": "2024-11-28",
      "endDate": "2024-12-25",
      "eventStatus": "https://schema.org/EventScheduled",
      "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
      "location": {
        "@type": "Place",
        "name": "Your Christmas Tree Company",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "West Los Angeles",
          "addressRegion": "CA",
          "addressCountry": "US"
        }
      }
    }
  };

  return (
    <>
      {/* Structured Data JSON-LD */}
      <script type="application/ld+json">
        {JSON.stringify(schemaData)}
      </script>

      <Box
        component="section"
        aria-label="Important Information - Hours and Delivery"
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-around",
          padding: "8px",
          flexWrap: "wrap",
        }}
      >
        {/* Hidden H1 for SEO */}
        <h1 className="visually-hidden">
          Christmas Tree Delivery Available - Open Daily 10AM to 9PM Starting November 28th
        </h1>

        {/* ---------Delivery start----------------*/}
        <Box
          component="article"
          className="deliver"
          sx={{
            display: "flex",
            padding: "16px",
            backgroundColor: "secondary.main",
            boxShadow: "10",
            borderRadius: "24px",
            margin: "16px",
          }}
          itemScope
          itemType="https://schema.org/Service"
        >
          <Typography
            component="h2"
            sx={{
              color: "text.main",
              fontSize: "50px",
              display: "flex",
              alignItems: "center",
            }}
            itemProp="name"
          >
            <LocalShippingIcon 
              sx={{ fontSize: "50px" }} 
              aria-hidden="true"
            />
            We Deliver!
          </Typography>
          <meta itemProp="serviceType" content="Christmas Tree Delivery" />
          <meta itemProp="description" content="Professional Christmas tree delivery service available" />
        </Box>

        {/* ---------Opening Date start----------------*/}
        <Box
          component="article"
          className="deliver"
          sx={{
            display: "flex",
            padding: "16px",
            backgroundColor: "secondary.main",
            boxShadow: "10",
            borderRadius: "24px",
            margin: "16px",
          }}
          itemScope
          itemType="https://schema.org/Event"
        >
          <Typography
            component="h2"
            sx={{
              color: "text.main",
              fontSize: "30px",
              display: "flex",
              alignItems: "center",
              gap: "6px",
            }}
            itemProp="name"
          >
            <span>We open</span>
            <time dateTime="2024-11-28" itemProp="startDate">
              November 28th!
            </time>
          </Typography>
          <meta itemProp="eventStatus" content="https://schema.org/EventScheduled" />
          <meta itemProp="description" content="Christmas tree lot opening day" />
        </Box>
        {/* ---------Opening Date end----------------*/}

        {/* ---------Hours start----------------*/}
        <Box
          component="article"
          className="Hours"
          sx={{
            display: "flex",
            flexDirection: "column",
            padding: "16px",
            backgroundColor: "secondary.main",
            boxShadow: "10",
            borderRadius: "24px",
            margin: "16px",
          }}
          itemScope
          itemType="https://schema.org/OpeningHoursSpecification"
        >
          <Box sx={{ display: "flex", flexDirection: "row" }}>
            <Typography
              component="h2"
              sx={{
                color: "text.main",
                display: "flex",
                alignItems: "center",
                fontSize: "30px",
              }}
            >
              <AccessTimeIcon aria-hidden="true" />
              Lot hours:
            </Typography>
          </Box>
          <Typography 
            component="p"
            sx={{ color: "text.main", fontSize: "20px" }}
          >
            <span itemProp="dayOfWeek" content="Monday,Tuesday,Wednesday,Thursday,Friday,Saturday,Sunday">
              Everyday
            </span>: <time itemProp="opens" content="10:00">10AM</time> – <time itemProp="closes" content="21:00">9PM</time>
          </Typography>
        </Box>
        {/* ---------Hours end----------------*/}
      </Box>
    </>
  );
}